module.exports = __webpack_public_path__ + "img/cornwall.2.9895d34.jpg";